import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Modal from "../../../../components/Modal";
import Button from "../../../../components/Button";
import Checkbox from "../../../../components/Inputs/Checkbox";
import { useProfileApi } from "../../../../utils/api/profile";
import { getErrorMessage } from "../../../../utils/helpers/errors";
import { useAuthentication } from "../../../Authentication/context";
import { useGeofencePunchGates } from "../../../../utils/hooks/useGeofencePunchGates";
import { useShiftAction } from "../store";

const PUNCH_ACTIONS = ["start-shift", "start-break", "end-break", "end-shift", "switch"];

function GeofenceConsentModal() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [shiftAction, { setShiftAction }] = useShiftAction();
	const { mustAcceptConsent } = useGeofencePunchGates();
	const { changeLocationServicesConsent } = useProfileApi();
	const { dispatch, user } = useAuthentication();
	const [checked, setChecked] = useState(false);
	const [loading, setLoading] = useState(false);

	const isOpen = PUNCH_ACTIONS.includes(shiftAction) && mustAcceptConsent;

	useEffect(() => {
		if (!isOpen) {
			setChecked(false);
		}
	}, [isOpen]);

	const onAgree = useCallback(async () => {
		setLoading(true);
		try {
			const response = await changeLocationServicesConsent({ status: true });
			dispatch({
				type: "set-user",
				payload: { user: response || user },
			});
		} catch (err) {
			getErrorMessage(err, t);
		} finally {
			setLoading(false);
		}
	}, [changeLocationServicesConsent, dispatch, t, user]);

	const onGoToDashboard = useCallback(() => {
		setShiftAction(null);
		navigate("/");
	}, [navigate, setShiftAction]);

	return (
		<Modal
			isOpen={isOpen}
			title={t("location-services-consent")}
			backdrop="static"
			keyboard={false}
			className="modal-dialog-centered"
		>
			<p className="mb-4">{t("geofence-consent-message")}</p>

			<Checkbox
				id="geofence-consent"
				checked={checked}
				onChange={(e) => setChecked(e.target.checked)}
			>
				{t("i-agree-to-location-services")}
			</Checkbox>

			<div className="d-flex justify-content-end mt-4">
				<Button
					className="btn-round btn-icon shadow-none border btn btn-secondary btn-sm"
					onClick={onGoToDashboard}
					disabled={loading}
					type="button"
				>
					{t("go-to-dashboard")}
				</Button>

				<Button
					color="primary"
					className="btn-round btn-icon shadow-none border px-3 btn btn-dark btn-sm"
					onClick={onAgree}
					disabled={!checked || loading}
					loading={loading}
					type="button"
				>
					{t("geofence-consent-agree")}
				</Button>
			</div>
		</Modal>
	);
}

export default GeofenceConsentModal;
